import { createReducer, FAILURE, REQUEST, SUCCESS, updateObject } from 'Stores'
import {
  GET_DATA_DASHBOARD,
  GET_DATA_TAB_CHART,
  GET_DATA_TOP_SEARCH
} from './constants'

export const initialState = {
  isLoading: false,
  error: null,
  dataDashboard: {
    proportionSales: null,
    summary: {}
  },
  dataChartTab: {
    userActivity: [],
    salesTrend: [],
    visits: []
  },
  topSearch: {
    data: {},
    filter: {}
  }
}

function getDataDashboard(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getDataDashboardSuccess(state, { payload }) {
  const { proportionSales, summary, userActivity, salesTrend, visits, dataTopSearch } = payload
  return updateObject(state, {
    isLoading: false,
    dataDashboard: {
      proportionSales,
      summary
    },
    dataChartTab: {
      userActivity,
      salesTrend,
      visits
    },
    topSearch: {
      data: dataTopSearch
    }
  })
}

function getDataDashboardError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getDataTabChart(state) {
  return updateObject(state, {
    isLoading: true
  })
}

function getDataTabChartSuccess(state, { payload }) {
  const { userActivity, salesTrend, visits } = payload
  return updateObject(state, {
    isLoading: false,
    dataChartTab: {
      userActivity,
      salesTrend,
      visits
    }
  })
}

function getDataTabChartError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

function getDataTopSearch(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    topSearch: {
      filter: payload
    }
  })
}

function getDataTopSearchSuccess(state, { payload }) {
  return updateObject(state, {
    isLoading: false,
    topSearch: {
      data: payload
    }
  })
}

function getDataTopSearchError(state, { error }) {
  return updateObject(state, {
    isLoading: false,
    error
  })
}

export default createReducer(initialState, {
  [REQUEST(GET_DATA_DASHBOARD)]: getDataDashboard,
  [SUCCESS(GET_DATA_DASHBOARD)]: getDataDashboardSuccess,
  [FAILURE(GET_DATA_DASHBOARD)]: getDataDashboardError,

  [REQUEST(GET_DATA_TAB_CHART)]: getDataTabChart,
  [SUCCESS(GET_DATA_TAB_CHART)]: getDataTabChartSuccess,
  [FAILURE(GET_DATA_TAB_CHART)]: getDataTabChartError,

  [REQUEST(GET_DATA_TOP_SEARCH)]: getDataTopSearch,
  [SUCCESS(GET_DATA_TOP_SEARCH)]: getDataTopSearchSuccess,
  [FAILURE(GET_DATA_TOP_SEARCH)]: getDataTopSearchError
})
